module.exports = __webpack_public_path__ + "static/img/vd-sub-null.66522899.png";